import { statuses } from './home.constant';

export const getCircleProgressCurrentValue = (currentValue, maxValue) => {
    if (!currentValue) {
        return 0;
    }

    const minValuePercent = 5;
    const minValue = minValuePercent * maxValue / 100;
    let result = currentValue > minValue ? currentValue : minValue;

    return result;
};

export const getCircleProgressRotateSpeed = (currentValue, maxValue) => {
    for (let i = 10; i >= 1; i--) {
        if (currentValue <= maxValue / i) return i;
    }

    return 1;
};

export const getStatuses = () => {
    return [statuses.Auto, statuses.Away, statuses.Home, statuses.Standby, statuses.Off];
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/core/home/home.helper.js